import { render, staticRenderFns } from "./UpdateLogistics.vue?vue&type=template&id=58c9fd34"
import script from "./UpdateLogistics.vue?vue&type=script&lang=js"
export * from "./UpdateLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports